import DialogTemplate from "./dialog/dialog.html";
import DialogController from "./dialog/dialog.controller";

class Controller {
  constructor(Events, $mdDialog) {
    "ngInject";

    this.Events = Events;
    this.$mdDialog = $mdDialog;
  }

  $onInit() {
    const onUpdateStationLoc =
      this.eventName || this.Events.eventsType.onUpdateStationLoc;
    const coords =
      this.selected &&
      this.selected.value &&
      !Array.isArray(this.selected.value) &&
      typeof this.selected.value !== "object"
        ? this.selected.value.split(",")
        : this.selected &&
          (Array.isArray(this.selected.value) ||
            typeof this.selected.value === "object")
        ? this.selected.value
        : [];
    const lat = coords.lat || coords[0];
    const lng = coords.lng || coords[1];
    this.text =
      coords.length > 0 || Object.keys(coords).length > 0
        ? Number(lat).toFixed(5) + "," + Number(lng).toFixed(5)
        : "";

    this.onFocus = () => {
      const add = this.$mdDialog.show({
        controller: DialogController,
        controllerAs: "$ctrl",
        template: DialogTemplate,
        multiple: true,
        locals: {
          latLong: coords,
        },
      });

      add.then(([lat, lng]) => {
        this.selected = {
          value: [lng, lat],
        };
        this.text = lat.toFixed(5) + "," + lng.toFixed(5);
      }, angular.noop);
    };

    this.enableField = () => {
      this.selected.isDisabled = false;
    };

    this.submitField = () => {
      const method = this.resourceMethod;
      const methodName = this.resourceMethodName;
      const type = "Point";
      const key = this.name;
      const value = { coordinates: this.selected.value, type };
      const options = {
        key,
        method,
        methodName,
        value,
      };

      this.Events.emit(onUpdateStationLoc, options);
      this.selected.isDisabled = true;
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/pickLocationMap/pickLocationMap.controller.js